/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ExternalCostAllocationDto interface.
 */
export function instanceOfExternalCostAllocationDto(value) {
    return true;
}
export function ExternalCostAllocationDtoFromJSON(json) {
    return ExternalCostAllocationDtoFromJSONTyped(json, false);
}
export function ExternalCostAllocationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'mese': json['mese'] == null ? undefined : json['mese'],
        'anno': json['anno'] == null ? undefined : json['anno'],
        'extimatedCost': json['extimatedCost'] == null ? undefined : json['extimatedCost'],
        'actualCost': json['actualCost'] == null ? undefined : json['actualCost'],
        'editEnabled': json['editEnabled'] == null ? undefined : json['editEnabled'],
    };
}
export function ExternalCostAllocationDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'mese': value['mese'],
        'anno': value['anno'],
        'extimatedCost': value['extimatedCost'],
        'actualCost': value['actualCost'],
        'editEnabled': value['editEnabled'],
    };
}
